import { render, staticRenderFns } from "./EventHistoryNewTenderStageCreatedParams.vue?vue&type=template&id=33e6eb06"
import script from "./EventHistoryNewTenderStageCreatedParams.vue?vue&type=script&lang=js"
export * from "./EventHistoryNewTenderStageCreatedParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports